import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertContext } from '../AlertContext';
import "../css/Login.css"

const Login = ({apiUrl, setAuthToken }) => {
  const { showAlert } = useContext(AlertContext);
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ email: '', password: '' });

  const gotoDashboard = () => {
    navigate('/dashboard');
  };

  const onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${apiUrl}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: credentials.email, password: credentials.password }),
    });
    const json = await response.json();
  
    if (json.success) {
      const authToken = json.authtoken;
      localStorage.setItem('token', authToken);
      setAuthToken(authToken);

      const getUsername = await fetch(`${apiUrl}/getauthadmin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': authToken,
        },
        body: JSON.stringify(),
      });
      const userjson = await getUsername.json();
      localStorage.setItem('username', userjson.username);

      showAlert('Logged in Successfully', 'success');
      gotoDashboard();
    } else {
      showAlert('Invalid Credentials', 'danger');
    }
  };

  return (
    <div className="wrapper">
      <div className="logo">
        <img src="img/Home/AquaTreat_1.jpg" alt="" />
      </div>
      <div className="text-center mt-4 name">Aqua Treat Systems <br /> (Only Admins)</div>
      <form className="p-3 mt-3" onSubmit={handleSubmit}>
        <div className="form-field d-flex align-items-center">
          <span className="far fa-user"></span>
          <input
            type="email"
            name="email"
            id="email"
            value={credentials.email}
            onChange={onChange}
            placeholder="Email"
            required
          />
        </div>
        <div className="form-field d-flex align-items-center">
          <span className="fas fa-key"></span>
          <input
            type="password"
            name="password"
            id="password"
            value={credentials.password}
            onChange={onChange}
            placeholder="Password"
            required
          />
        </div>
        <button type="submit" className="btn mt-3">
          Login
        </button>
      </form>
    </div>
  );
};

export default Login;
